import { setCookie } from '../../utils/package-cookies'
import Vue from 'vue'
const GetIpMothod = {

  getUserIP : (onNewIP) => {
    let flag =true;
    const myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    if (myPeerConnection) {
      const pc = new myPeerConnection({ iceServers: [] });
      const noop = function () { };
      const localIPs = {};
      const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
      const key = null;
    
      function iterateIP(ip) {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
      }
      if(1 || window.mozRTCPeerConnection) {
        pc.createDataChannel('', {reliable:false});
      }else{
        flag= false
      }
  
    
      pc.createOffer().then((sdp) => {
        sdp.sdp.split('\n').forEach((line) => {
          if (line.indexOf('candidate') < 0) return;
          line.match(ipRegex).forEach(iterateIP);
        });
        pc.setLocalDescription(sdp, noop, noop);
      }).catch((reason) => { });
    
      pc.onicecandidate = function (ice) {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    }
    else{
      flag= false 
    }
   
    if(!flag){
      Vue.prototype.$message({
        message: '"请使用主流浏览器：chrome,firefox,opera,safari"',
        type: "warning"
      });
    }
  
  },

  getCurrIp() {
    this.getUserIP((ip) => {
      setCookie("LocalIp", ip, 20);
    });
  }
}
export default GetIpMothod





